/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleMargin extends models.BillingRulePercentageCalculate {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleMargin");
    }

    getFixupPrototypeFunction() { return BillingRuleMargin.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleMargin>): BillingRuleMargin {
        let obj = Object.assign(new BillingRuleMargin(), model);
        BillingRuleMargin.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleMargin>): BillingRuleMargin {
        if (!model) return null;
        return BillingRuleMargin.newInstance(<BillingRuleMargin> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleMargin) {
        if (!obj) return;

        models.BillingRuleMargin.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleMargin): boolean {
        if (models.BillingRulePercentageCalculate.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleMargin.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
